import React from "react";
import { i18n } from "../../../services/i18nService";
import { List } from "../../../services/visualLibraryService";

export const Profile = ({ userAccount }) => {
  const userAccountData = {
    [`${i18n.get("pages.settings.profile.firstName")}`]: userAccount && userAccount.firstName,
    [`${i18n.get("pages.settings.profile.lastName")}`]: userAccount && userAccount.lastName,
    [`${i18n.get("pages.settings.profile.emailNumber")}`]: userAccount && userAccount.emailAddress
  };

  return (
    // TODO think on the MSISDN case too
    <List data={userAccountData} type="dl" />
  );
};
